(() => {
  const root = document.querySelector('[data-auren-password-landing]');
  const scope = root || document;
  if (!root && !document.querySelector('.auren-public')) return;

  const setText = (counterRoot, selector, value) => {
    const node = counterRoot.querySelector(selector);
    if (node) node.textContent = String(value).padStart(2, '0');
  };

  const countdownRoots = Array.from(document.querySelectorAll('[data-auren-countdown-root]'));

  const updateCountdown = (counterRoot) => {
    const targetRaw = counterRoot.getAttribute('data-countdown-target');
    const target = targetRaw ? new Date(targetRaw) : null;
    const countdown = counterRoot.querySelector('[data-auren-countdown]');
    if (!target || Number.isNaN(target.getTime()) || !countdown) return;
    const diff = Math.max(0, target.getTime() - Date.now());
    const totalMinutes = Math.floor(diff / 60000);
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;
    setText(counterRoot, '[data-countdown-days]', days);
    setText(counterRoot, '[data-countdown-hours]', hours);
    setText(counterRoot, '[data-countdown-minutes]', minutes);
  };

  const updateAllCountdowns = () => countdownRoots.forEach(updateCountdown);

  updateAllCountdowns();
  window.setInterval(updateAllCountdowns, 60000);

  const track = (eventName, payload = {}) => {
    if (typeof window.fbq !== 'function') return;
    if (eventName === 'Lead') {
      window.fbq('track', 'Lead', payload);
    } else {
      window.fbq('trackCustom', eventName, payload);
    }
  };

  scope.querySelectorAll('a[href*="indiegogo.com"]').forEach((link) => {
    link.addEventListener('click', () => {
      track('IndiegogoClick', {
        source: 'auren_dawn_prelaunch',
        destination: link.href
      });
    });
  });

  const trackingKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'ref'];
  const trackingStoreKey = 'auren_tracking_params';
  const params = new URLSearchParams(window.location.search);
  const readStoredTracking = () => {
    try {
      return JSON.parse(window.sessionStorage.getItem(trackingStoreKey) || '{}');
    } catch (error) {
      return {};
    }
  };
  const storedTracking = readStoredTracking();
  const nextTracking = { ...storedTracking };

  trackingKeys.forEach((key) => {
    const value = params.get(key);
    if (value) nextTracking[key] = value;
  });

  if (!nextTracking.ref && document.referrer) {
    nextTracking.ref = document.referrer;
  }

  try {
    window.sessionStorage.setItem(trackingStoreKey, JSON.stringify(nextTracking));
  } catch (error) {}

  scope.querySelectorAll('[data-auren-tracking-field]').forEach((field) => {
    const key = field.getAttribute('data-auren-tracking-field');
    if (key && nextTracking[key] && !field.value) {
      field.value = nextTracking[key];
    }
  });

  scope.querySelectorAll('form[action*="/contact"], form[id*="Waitlist"]').forEach((form) => {
    form.addEventListener('submit', () => {
      track('Lead', {
        content_name: 'Ouren M1 waitlist',
        source: 'auren_dawn_prelaunch'
      });
    });
  });

  scope.querySelectorAll('[data-auren-vip-form]').forEach((form) => {
    form.addEventListener('submit', () => {
      track('VIPReservationStart', {
        content_name: '$1 Early Bird Perk',
        source: 'auren_dawn_prelaunch',
        utm_source: nextTracking.utm_source || ''
      });
    });
  });

  const loadVideo = (wrap) => {
    const video = wrap.querySelector('video');
    if (!video || video.dataset.aurenLoaded === 'true') return video;
    video.querySelectorAll('source[data-src]').forEach((source) => {
      source.src = source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.aurenLoaded = 'true';
    video.load();
    return video;
  };

  const lazyVideos = Array.from(scope.querySelectorAll('[data-auren-lazy-video]'));
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            loadVideo(entry.target);
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '240px 0px' }
    );
    lazyVideos.forEach((wrap) => observer.observe(wrap));
  }

  scope.querySelectorAll('[data-auren-video-toggle]').forEach((button) => {
    button.addEventListener('click', () => {
      const wrap = button.closest('[data-auren-lazy-video]');
      const video = wrap ? loadVideo(wrap) : null;
      if (!video) return;
      if (video.paused) {
        video.play().catch(() => {});
        button.textContent = 'Pause POV demo';
      } else {
        video.pause();
        button.textContent = 'Play POV demo';
      }
    });
  });
})();

(() => {
  // Every {% form 'customer' %} / {% form 'contact' %} on the site that uses
  // the shared .auren-signup-modal convention (footer, hero, popup, EB step 1,
  // M1 page, password page) does a full-page POST + redirect on submit, which
  // throws away the visitor's scroll position. Save it here, on every page,
  // before the navigation happens, so the reveal script below can put the
  // visitor back where they actually were -- not wherever the browser's own
  // #hash-driven scroll happens to land (confirmed live 2026-09-03: a popup
  // submitted mid-scroll on the homepage sent the visitor back to the top of
  // the page instead of back to where the popup interrupted them).
  const KEY = 'auren_form_scroll_y';
  document.querySelectorAll('form[id]').forEach((form) => {
    if (!document.getElementById(`${form.id}-success`)) return;
    form.addEventListener('submit', () => {
      try { sessionStorage.setItem(KEY, String(window.scrollY)); } catch (e) {}
    });
  });
})();

(() => {
  // Liquid's form.posted_successfully? is one global flag shared by every
  // {% form 'customer' %} block on a page -- it can't tell WHICH form was
  // submitted when a page has more than one (it does even on this site: most
  // pages have both a hero waitlist form and the footer signup form). id: on
  // the form tag only sets the HTML id attribute; form.id itself is always
  // nil, so Liquid alone can't disambiguate here.
  // https://github.com/Shopify/liquid/issues/1650
  //
  // Fix: every form's confirmation is a modal dialog, always in the DOM but
  // hidden (markup: sections/*.liquid, styling: .auren-signup-modal* below),
  // and this reveals only the one matching the #hash Shopify appends on a
  // successful redirect (confirmed reliable: a real submission lands on
  // "?customer_posted=true#<form id>"), which is form-specific where the
  // Liquid flag isn't.
  //
  // {% form 'contact' %} is a different form type from {% form 'customer' %}
  // and uses its own query param on success -- "?contact_posted=true" --
  // confirmed against Shopify's own docs, not assumed from the customer-form
  // case. Both are checked here since this same script covers both types.
  const posted = window.location.search.indexOf('customer_posted=true') !== -1
    || window.location.search.indexOf('contact_posted=true') !== -1;
  if (!posted) return;

  const targetId = window.location.hash.replace('#', '');
  const modal = targetId && document.getElementById(`${targetId}-success`);

  if (!modal) {
    // Not one of this script's modals (e.g. the Early Bird page's own step 1
    // form, which swaps content inline instead of using this shared modal).
    // Leave the URL alone entirely and let the page-specific script that
    // actually owns this hash do its own cleanup -- this script stripping
    // "customer_posted=true" from the query here, before that other script
    // gets a turn to run later in this same file, was a real, previously
    // shipped bug: sections/auren-vip-reservation.liquid's own justPosted
    // check reads that exact query param, and by the time it ran the query
    // was already gone, so justPosted was silently always false. Step 1 to
    // step 2 still visibly unlocked regardless (the fallback path below,
    // "already done on a previous visit", covers it because the email was
    // already written to localStorage before the redirect) -- so nothing
    // looked broken, it just always unlocked WITHOUT the intended animate/
    // scroll-to-step-2 behaviour (reported live 2026-09-03).
    return;
  }

  // Strip BOTH the query and the hash immediately, before doing anything
  // else. Two separate bugs traced back to leaving the hash in the URL:
  // (1) the browser's own "scroll to the fragment" step can re-run later,
  // while the page is still loading subresources (this hero has a video),
  // and silently re-jump to the form's own on-page position even after we
  // restore the visitor's real scroll position below; (2) some forms on
  // this site (the popup's) target a form that is `hidden` at load, which
  // the browser can't scroll to at all, so it does nothing and just leaves
  // the visitor at the page's default top -- also wrong. Cutting the hash
  // off here removes the target before either can fire.
  window.history.replaceState({}, document.title, window.location.pathname);

  // Hoist to a direct child of <body>, unconditionally, before revealing it.
  // This modal is shared across every page and form on the site (footer,
  // hero, popup, M1 page, password page) and some of those spots sit inside
  // an ancestor that starts its own stacking context (the homepage hero uses
  // `isolation: isolate` so its full-bleed video scrim never bleeds into the
  // page below it). A z-index inside a stacking context only ever wins
  // against siblings *inside that same context* -- it does not out-rank a
  // later, unrelated section of the page that creates its own context (this
  // homepage's "Meet Ouren M1" scroll section pins its own viewport with
  // `position: sticky`, which always creates one). The visible bug: the
  // modal, though genuinely `position: fixed` and covering the viewport,
  // painted *underneath* that later section while scrolled into it, and
  // only reappeared on top once scrolled back up into the hero's own local
  // stack (seen live 2026-09-03, screenshot from Simon). Moving the element
  // itself to <body> puts it in the true root stacking context, which
  // nothing on this site nests inside, so this fixes every page that reuses
  // this modal, not just the homepage.
  if (modal.parentNode !== document.body) document.body.appendChild(modal);

  const closeModal = () => { modal.hidden = true; };
  modal.hidden = false;
  // Clicking the dimmed backdrop (not the card itself) dismisses, same as the OK button.
  modal.addEventListener('click', (event) => {
    if (event.target === modal) closeModal();
  });
  modal.querySelectorAll('[data-auren-modal-dismiss]').forEach((btn) => {
    btn.addEventListener('click', closeModal);
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeModal();
  });

  // Restore the scroll position saved just before this submit (see the IIFE
  // above). Applied twice on purpose: once now, and once more on window
  // 'load' -- the same later "scroll to the fragment" re-run described above
  // can otherwise win a race against a restore that only happens once, early.
  const restoreScroll = () => {
    let y = null;
    try { y = sessionStorage.getItem('auren_form_scroll_y'); } catch (e) {}
    if (y === null) return;
    window.scrollTo(0, Number(y));
  };
  restoreScroll();
  window.addEventListener('load', () => {
    restoreScroll();
    try { sessionStorage.removeItem('auren_form_scroll_y'); } catch (e) {}
  });
})();

(() => {
  // Keeps --auren-announcement-height in sync with the announcement bar's
  // real rendered height, so the nav header (Dawn's own on-scroll-up sticky
  // reveal, base.css .shopify-section-header-sticky) can sit just below it
  // instead of both landing on top:0 and overlapping when the header
  // re-reveals mid-scroll. A fixed rem guess would drift -- the bar's real
  // height changes with text length/wrapping and breakpoint. Runs on every
  // page (not gated behind .auren-public like the rest of this file), since
  // the announcement bar itself is site-wide, including on pages that
  // aren't .auren-public at all.
  const bar = document.querySelector('.utility-bar');
  if (!bar) return;

  const setHeight = () => {
    document.documentElement.style.setProperty('--auren-announcement-height', `${bar.offsetHeight}px`);
  };

  setHeight();
  window.addEventListener('resize', setHeight);
  if ('ResizeObserver' in window) {
    new ResizeObserver(setHeight).observe(bar);
  }
})();

(() => {
  // Light/dark mode toggle (snippets/auren-theme-toggle.liquid).
  //
  // The active theme is already on <html> before the first paint, set by
  // the small blocking script in layout/theme.liquid -- deliberately not
  // here, because this file is deferred and would resolve the theme only
  // after the page had already painted in the wrong one. This block owns
  // the parts that can safely wait: reacting to the button, persisting
  // the visitor's choice, and keeping the button's state accessible.
  // Light is always the starting theme (see layout/theme.liquid) -- this
  // block only ever moves to dark in response to a click, and never reads
  // prefers-color-scheme. There is deliberately no "follow the OS" mode.
  const root = document.documentElement;
  const toggles = Array.from(document.querySelectorAll('[data-auren-theme-toggle]'));
  if (!toggles.length) return;

  const storageKey = 'auren-theme';
  const isDark = () => root.getAttribute('data-auren-theme') === 'dark';

  // aria-pressed rather than a label that changes: the button's label says
  // what the control is, and the pressed state says which mode is on. That
  // is one translated string instead of two that must stay in sync.
  const syncButtons = () => {
    toggles.forEach((button) => button.setAttribute('aria-pressed', String(isDark())));
  };

  const apply = (theme) => {
    root.setAttribute('data-auren-theme', theme);
    // Safari throws outright on localStorage in private browsing, so this
    // is guarded -- the toggle still works for the session, it just cannot
    // remember the choice across page loads.
    try {
      window.localStorage.setItem(storageKey, theme);
    } catch {}
    syncButtons();
  };

  syncButtons();

  toggles.forEach((button) => {
    button.addEventListener('click', () => apply(isDark() ? 'light' : 'dark'));
  });
})();

(() => {
  // Ouren M1 sales page: thumbnail gallery switcher.
  const root = document.querySelector('.auren-m1-showcase');
  if (!root) return;
  const main = root.querySelector('[data-auren-m1-main]');
  const thumbs = Array.from(root.querySelectorAll('[data-auren-m1-thumb]'));
  if (!main || thumbs.length === 0) return;
  thumbs.forEach((thumb) => {
    thumb.addEventListener('click', () => {
      const url = thumb.getAttribute('data-auren-m1-thumb');
      if (!url || main.getAttribute('src') === url) return;
      main.setAttribute('src', url);
      thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));
    });
  });
})();

/* ============================================================
   Homepage section 2 -- "Meet Ouren M1"

   One scroll-driven take over a 263-frame alpha-WebP render sequence, across
   three acts (see snippets/auren-meet-m1.liquid for the storyboard).

   Deliberately ONE code path for desktop and mobile. The previous version of
   this section ran a scroll-scrubbed stage on desktop and a separate set of
   fade-in-once mobile elements, which is why the two drifted apart. Here the
   same progress value drives the same frames in the same order on every
   device; only CSS decides where the copy sits.

   Progressive enhancement: the markup renders as a plain stacked story with
   the photo visible. This script adds .auren-meet--live to switch on the
   pinned, scroll-scrubbed version, so no-JS and reduced-motion visitors get
   the readable static version rather than three captions piled on each other.
   ============================================================ */
(() => {
  const roots = Array.from(document.querySelectorAll('[data-auren-meet]'));
  if (!roots.length) return;

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
  const lerp = (a, b, t) => a + (b - a) * t;
  // Normalised 0->1 ramp between two scroll positions.
  const ramp = (edge0, edge1, v) => clamp((v - edge0) / (edge1 - edge0), 0, 1);
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  // --- Where the M1 sits inside a render frame, at the last frame we use.
  // Measured off the source PNG's alpha bounding box (frame 262, 2000x2000):
  // bbox (257,313)-(1743,1759) -> as fractions of the square frame. Needed to
  // land the DEVICE, not the canvas, on the collar.
  const DEVICE_CX = 0.5;
  const DEVICE_CY = 0.518;
  const DEVICE_W = 0.743;

  // --- Where the real M1 sits on the collar in auren-story-poodle-worn.jpg,
  // as a fraction of that photo's intrinsic pixels. Measured directly off the
  // photo. The landing is computed from these against the photo's actual
  // rendered geometry, so it stays on the collar at any viewport or crop.
  const COLLAR_CX = 0.586;
  const COLLAR_CY = 0.557;
  const COLLAR_W = 0.128;

  // --- Scroll choreography. Every band is a fraction of the section's own
  // scroll length (720vh track, see auren-dawn-prelaunch.css), so the pacing
  // is identical on every screen size. Built from explicit vh budgets, not
  // guessed fractions -- a first pass just stretched act 1/3 somewhat and
  // still left them shorter than act 2's spin, which is the one part of the
  // section a visitor can't outrun (the rotation takes real scroll no matter
  // how hard you flick). So this version sets three EQUAL 180vh blocks --
  // act 1 static hold, act 2 spin, act 3 static dwell -- joined by two 90vh
  // transition zones (fade + entrance, fade + landing):
  //
  //   0        180  270        450  540        720   vh
  //   |--hold1--|-T1-|--spin----|-T2-|--hold3----|
  //   act 1 static   act 2 turning    act 3 static
  //
  // A strong flick would need to cover a full 180vh (>1.5 screens on a
  // typical laptop) to clear act 1 or act 3 outright -- the same distance it
  // would need to blow through the spin, which nothing has reported doing.
  const T = {
    photoOut: [0.264, 0.331], // establishing photo dissolves to a clean stage
    enter: [0.278, 0.375], // canvas slides + fades in from the right edge
    spin: [0.375, 0.625], // hold anchor -> last frame, one full turn (180vh)
    photoIn: [0.632, 0.708], // photo returns for the landing
    land: [0.639, 0.75], // device shrinks + drifts onto the collar
    wornIn: [0.694, 0.75], // empty-collar photo crossfades to the worn one
    act1Out: [0.25, 0.32],
    act2In: [0.306, 0.375],
    act2Out: [0.625, 0.681],
    act3In: [0.667, 0.75],
    hintIn: [0, 0.02], // fades up fast right as the section starts pinning
    hintOut: [0.96, 1], // fades out before the section releases
  };

  roots.forEach((root) => {
    const stage = root.querySelector('[data-meet-stage]');
    const canvas = root.querySelector('[data-meet-canvas]');
    const photoWrap = root.querySelector('[data-meet-photo]');
    const photoWorn = root.querySelector('[data-meet-photo-worn]');
    const acts = Array.from(root.querySelectorAll('[data-meet-act]'));
    const hint = root.querySelector('[data-meet-hint]'); // optional, not required to run
    if (!stage || !canvas || !photoWrap || !photoWorn) return;

    const ctx = canvas.getContext('2d');
    const base = root.dataset.seqBase || '';
    const suffix = root.dataset.seqSuffix || '';
    const count = parseInt(root.dataset.seqCount, 10) || 0;
    const holdFrame = parseInt(root.dataset.seqHold, 10) || 0;
    const lastFrame = count - 1;
    if (!count) return;

    const frames = new Array(count);
    const ready = new Array(count).fill(false);
    let lastDrawn = -1;
    let listening = false;
    let queued = false;

    const frameUrl = (i) => base + 'auren-m1-seq-' + String(i).padStart(3, '0') + '.webp' + suffix;

    function loadFrame(i, done) {
      if (frames[i]) {
        if (ready[i] && done) done();
        return;
      }
      const img = new Image();
      img.decoding = 'async';
      img.onload = () => {
        ready[i] = true;
        if (done) done();
      };
      img.src = frameUrl(i);
      frames[i] = img;
    }

    // Nearest already-decoded frame to i, so early scrolling shows something
    // sensible instead of a blank stage while the sequence streams in.
    const nearestReady = (i) => {
      for (let d = 0; d < count; d += 1) {
        if (i - d >= 0 && ready[i - d]) return i - d;
        if (i + d < count && ready[i + d]) return i + d;
      }
      return -1;
    };

    const sizeCanvas = () => {
      const w = canvas.offsetWidth;
      if (!w) return;
      // Cap DPR at 2: past that the extra pixels cost real memory on phones
      // and buy nothing visible on a soft-shaded product render.
      const dpr = Math.min(window.devicePixelRatio || 1, 2);
      const px = Math.round(w * dpr);
      if (canvas.width !== px) {
        canvas.width = px;
        canvas.height = px; // frames are square
        lastDrawn = -1; // force a redraw at the new backing size
      }
    };

    const drawFrame = (i) => {
      const idx = ready[i] ? i : nearestReady(i);
      if (idx < 0 || idx === lastDrawn) return;
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.drawImage(frames[idx], 0, 0, canvas.width, canvas.height);
      lastDrawn = idx;
    };

    // Map the photo's intrinsic collar point into viewport pixels, accounting
    // for object-fit: cover cropping. This is what keeps the landing on the
    // collar when the photo is cropped tall on a phone and wide on a desktop.
    const collarGeometry = () => {
      const box = photoWrap.getBoundingClientRect();
      const iw = photoWorn.naturalWidth || 922;
      const ih = photoWorn.naturalHeight || 1152;
      const s = Math.max(box.width / iw, box.height / ih);
      const rw = iw * s;
      const rh = ih * s;
      return {
        x: box.left + (box.width - rw) / 2 + COLLAR_CX * rw,
        y: box.top + (box.height - rh) / 2 + COLLAR_CY * rh,
        width: COLLAR_W * rw,
      };
    };

    const render = () => {
      queued = false;

      const rect = root.getBoundingClientRect();
      const total = rect.height - window.innerHeight;
      const p = total > 0 ? clamp(-rect.top / total, 0, 1) : 0;

      // ---- frame index: held on the fly-in anchor (飞入固定, orig frame 56)
      // through the whole entrance, THEN scrubbed for the turn. The source
      // render's own frames 0-55 are an extreme macro dolly across the
      // plastic (see the storyboard) -- fine watched at speed in the
      // original video, but scrubbed frame-by-scroll-frame they read as a
      // glitchy close-up crop, not a product "flying in". So the entrance
      // motion here is real CSS translation (below), and the frame stays on
      // a clean, fully-composed shot of the device throughout it.
      const frame = p < T.spin[0] ? holdFrame : Math.round(lerp(holdFrame, lastFrame, ramp(T.spin[0], T.spin[1], p)));
      drawFrame(clamp(frame, 0, lastFrame));

      // ---- establishing photo out, then back for the landing
      const photoVisible = 1 - ramp(T.photoOut[0], T.photoOut[1], p) + ramp(T.photoIn[0], T.photoIn[1], p);
      photoWrap.style.opacity = String(clamp(photoVisible, 0, 1));
      photoWorn.style.opacity = String(ramp(T.wornIn[0], T.wornIn[1], p));

      // ---- canvas transform: two mutually-exclusive phases (enter and land
      // never overlap in T, so exactly one contributes at any scroll
      // position) sharing one transform/opacity write.
      const enter = ramp(T.enter[0], T.enter[1], p);
      const land = ramp(T.land[0], T.land[1], p);

      if (land > 0) {
        // Shrink + drift the canvas so the DEVICE, not the canvas box, comes
        // to rest on the collar, then dissolve it into the photo, whose own
        // device is fading up underneath at the same time.
        //
        // Geometry must be read UNTRANSFORMED. getBoundingClientRect() on the
        // canvas would include last frame's transform and feed back into
        // itself, so take the stage's rect (never transformed) and the
        // canvas's layout offsets within it instead.
        const stageRect = stage.getBoundingClientRect();
        const cw = canvas.offsetWidth;
        const ch = canvas.offsetHeight;
        const cx = stageRect.left + canvas.offsetLeft + cw / 2;
        const cy = stageRect.top + canvas.offsetTop + ch / 2;
        const collar = collarGeometry();
        // Scale that makes the rendered device match the photo's device width.
        const s = lerp(1, collar.width / (DEVICE_W * cw), land);
        // The canvas scales about its own centre, so the device centre ends up
        // at canvasCentre + deviceOffsetFromCentre * s + translate.
        const tx = collar.x - cx - (DEVICE_CX - 0.5) * cw * s;
        const ty = collar.y - cy - (DEVICE_CY - 0.5) * ch * s;
        canvas.style.transform =
          'translate(' + lerp(0, tx, land) + 'px,' + lerp(0, ty, land) + 'px) scale(' + s + ')';
        // Dissolve only at the very end, once it is already collar-sized.
        canvas.style.opacity = String(1 - ramp(0.72, 1, land));
      } else if (enter < 1) {
        // Slide in from the right edge of the stage + fade up. offsetWidth,
        // not getBoundingClientRect, since the canvas carries no transform
        // yet at this point in the timeline (enter and land never overlap).
        const startX = canvas.offsetWidth * 0.55;
        canvas.style.transform = 'translateX(' + lerp(startX, 0, enter) + 'px)';
        canvas.style.opacity = String(enter);
      } else {
        canvas.style.transform = '';
        canvas.style.opacity = '1';
      }

      // ---- copy cross-fade
      const opacities = [
        1 - ramp(T.act1Out[0], T.act1Out[1], p),
        ramp(T.act2In[0], T.act2In[1], p) * (1 - ramp(T.act2Out[0], T.act2Out[1], p)),
        ramp(T.act3In[0], T.act3In[1], p),
      ];
      acts.forEach((el, i) => {
        const o = opacities[i] || 0;
        el.style.opacity = String(o);
        el.style.transform = 'translateY(' + lerp(14, 0, o) + 'px)';
      });

      // ---- "keep scrolling" hint. Gated on being genuinely pinned, not
      // just on p: p alone reads as 0 both before the section is reached
      // AND at the exact instant pinning starts, and reads as 1 both at the
      // exact instant it releases AND long after -- rect.top distinguishes
      // "haven't arrived" / "actively pinned" / "already left" where p can't.
      if (hint) {
        const pinned = total > 0 && rect.top <= 0 && rect.top > -total;
        const hintOpacity = pinned
          ? ramp(T.hintIn[0], T.hintIn[1], p) * (1 - ramp(T.hintOut[0], T.hintOut[1], p))
          : 0;
        hint.style.opacity = String(hintOpacity);
      }
    };

    const onScroll = () => {
      if (!listening || queued) return;
      queued = true;
      window.requestAnimationFrame(render);
    };

    // Stream the sequence in small batches. Requesting 263 images at once
    // stalls the connection and competes with the rest of the page; batching
    // gets the first frames in quickly and fills the rest in behind.
    const preload = () => {
      let i = 0;
      const step = () => {
        const end = Math.min(i + 8, count);
        for (; i < end; i += 1) loadFrame(i);
        if (i < count) window.setTimeout(step, 60);
      };
      step();
    };

    const init = () => {
      // Reduced motion keeps the static, stacked version: no pinning, no
      // scrubbing, both photos and the copy simply in normal document flow.
      if (reduceMotion.matches) {
        root.classList.remove('auren-meet--live');
        [canvas, photoWrap, photoWorn].forEach((el) => el.removeAttribute('style'));
        acts.forEach((el) => el.removeAttribute('style'));
        if (hint) hint.removeAttribute('style');
        return;
      }
      root.classList.add('auren-meet--live');
      sizeCanvas();
      preload();
      render();
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => {
      sizeCanvas();
      onScroll();
    });
    reduceMotion.addEventListener('change', init);

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            listening = entry.isIntersecting;
            if (listening && !reduceMotion.matches) render();
          });
        },
        { rootMargin: '300px 0px' }
      );
      io.observe(root);
    } else {
      listening = true;
    }

    if (document.readyState === 'complete') init();
    else window.addEventListener('load', init, { once: true });
  });
})();

/* ============================================================
   Homepage section 3 -- "Product Functions"

   A peeking horizontal card carousel (apple.com/iphone-17-pro "Get the
   highlights" gallery pattern) on a native horizontal scroll-snap track.
   Cards aren't a fixed fraction of the track's width -- unlike the old
   full-bleed version (and the older phone-panel carousel before that),
   `Math.round(scrollLeft / clientWidth)` can't recover the active index,
   so the active card is instead whichever card's own resting (centered)
   scroll position is closest to the current `scrollLeft`, which holds
   regardless of card width, gaps, or the track's own edge padding.
   On top of that base: autoplay with a progress-filling active dot,
   play/pause toggle, pause when off-screen or under reduced motion.

   State model, deliberately simple: the play/pause BUTTON is the only
   thing that turns autoplay on or off. Clicking a dot or dragging the
   track changes which slide is showing and restarts the current slide's
   countdown, but never silently flips play/pause state on its own --
   a user who presses play should not find it silently paused just
   because they dragged once, and a user who presses pause should not
   find it silently resumed by an unrelated dot click.
   ============================================================ */
(() => {
  const roots = Array.from(document.querySelectorAll('[data-auren-functions]'));
  if (!roots.length) return;

  const INTERVAL = 6000; // ms a slide dwells before auto-advancing
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  roots.forEach((root) => {
    const track = root.querySelector('[data-functions-track]');
    const slides = Array.from(root.querySelectorAll('[data-functions-slide]'));
    const dots = Array.from(root.querySelectorAll('[data-functions-dot]'));
    const playPause = root.querySelector('[data-functions-playpause]');
    const controls = root.querySelector('.auren-functions__controls');
    if (!track || !slides.length || !dots.length) return;

    let activeIndex = 0;
    let userWantsAutoplay = !reduceMotion.matches;
    let isIntersecting = false;
    let timerId = null;
    let scrolling = false; // true while OUR OWN scrollTo() is animating
    let scrollEndTimeout = null;

    const setPlayPauseUI = () => {
      if (!playPause) return;
      const playing = userWantsAutoplay && isIntersecting;
      playPause.classList.toggle('is-paused', !playing);
      playPause.setAttribute('aria-pressed', String(playing));
      playPause.setAttribute(
        'aria-label',
        playing ? playPause.dataset.labelPause : playPause.dataset.labelPlay
      );
    };

    const restartFill = (index) => {
      dots.forEach((dot, i) => {
        const fill = dot.querySelector('[data-functions-dot-fill]');
        if (!fill) return;
        fill.classList.remove('is-filling');
        if (i !== index) return;
        if (!(userWantsAutoplay && isIntersecting)) return;
        // Force reflow so removing+re-adding the class actually restarts
        // the CSS animation instead of being a no-op.
        void fill.offsetWidth; // eslint-disable-line no-unused-expressions
        fill.style.animationDuration = INTERVAL + 'ms';
        fill.classList.add('is-filling');
      });
    };

    const setActive = (index) => {
      activeIndex = index;
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      // Cards have no focusable content of their own (no links/buttons),
      // so unlike a typical carousel there's nothing to remove from tab
      // order here -- the class exists purely to drop the "clickable"
      // cursor once a card becomes the active one (see the card click
      // handler below).
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
    };

    const clearTimer = () => {
      if (timerId) {
        window.clearTimeout(timerId);
        timerId = null;
      }
    };

    // Cards are `scroll-snap-align: center`, so a card's resting scroll
    // position is the one that centers it in the track, not its own
    // `offsetLeft`. Scrolling to `offsetLeft` would land half a card off
    // and then get yanked back by the snap, which reads as a bounce.
    // Derived from the track's current width rather than the CSS edge
    // padding so it stays correct at any card width.
    const scrollTargetFor = (slide) =>
      slide.offsetLeft - (track.clientWidth - slide.offsetWidth) / 2;

    const nearestIndex = () => {
      let best = 0;
      let bestDistance = Infinity;
      slides.forEach((slide, i) => {
        const distance = Math.abs(scrollTargetFor(slide) - track.scrollLeft);
        if (distance < bestDistance) {
          bestDistance = distance;
          best = i;
        }
      });
      return best;
    };

    const goTo = (index, { userInitiated } = {}) => {
      const clamped = ((index % slides.length) + slides.length) % slides.length;
      scrolling = true;
      track.scrollTo({
        left: scrollTargetFor(slides[clamped]),
        behavior: userInitiated && reduceMotion.matches ? 'auto' : 'smooth',
      });
      setActive(clamped);
      restartTimer();
    };

    function restartTimer() {
      clearTimer();
      restartFill(activeIndex);
      if (!(userWantsAutoplay && isIntersecting)) return;
      timerId = window.setTimeout(() => {
        goTo(activeIndex + 1);
      }, INTERVAL);
    }

    // ---- scroll-driven dot sync (manual drag/swipe, or momentum after our
    // own scrollTo). Distinguishing "still our programmatic scroll settling"
    // from "user grabbed the track" isn't reliable via events alone, so this
    // just re-derives the true index from scroll position on every scroll,
    // which is correct either way -- it only ever disagrees with `activeIndex`
    // when the user actually moved the track themselves.
    let scrollTicking = false;
    track.addEventListener(
      'scroll',
      () => {
        if (scrollTicking) return;
        scrollTicking = true;
        window.requestAnimationFrame(() => {
          scrollTicking = false;
          const index = nearestIndex();
          if (index !== activeIndex) {
            setActive(index);
            restartTimer();
          }
        });
      },
      { passive: true }
    );

    // A real user grab (not our own smooth-scroll settling) restarts the
    // countdown so the slide they land on gets its full dwell time.
    track.addEventListener(
      'pointerdown',
      () => {
        scrolling = false;
        window.clearTimeout(scrollEndTimeout);
      },
      { passive: true }
    );
    track.addEventListener(
      'scrollend',
      () => {
        if (scrolling) {
          scrolling = false;
          return;
        }
        restartTimer();
      },
      { passive: true }
    );
    // Safari (as of this writing) has no 'scrollend' -- approximate it with
    // a debounce so this branch degrades to "restarts a bit late" rather
    // than "never restarts".
    if (!('onscrollend' in window)) {
      track.addEventListener(
        'scroll',
        () => {
          window.clearTimeout(scrollEndTimeout);
          scrollEndTimeout = window.setTimeout(() => {
            if (!scrolling) restartTimer();
          }, 120);
        },
        { passive: true }
      );
    }

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => goTo(index, { userInitiated: true }));
    });

    // Clicking the peeking next (or previous) card's visible edge
    // navigates to it, same as clicking its dot -- previously only
    // dragging/swiping the track or clicking a dot could change slides.
    // A click on the currently-active card is a no-op: nowhere to go.
    slides.forEach((slide, index) => {
      slide.addEventListener('click', () => {
        if (index === activeIndex) return;
        goTo(index, { userInitiated: true });
      });
    });

    if (playPause) {
      // data-label-play / data-label-pause come from the snippet, already
      // localized -- dataset.labelPlay/labelPause read them directly.
      playPause.addEventListener('click', () => {
        userWantsAutoplay = !userWantsAutoplay;
        setPlayPauseUI();
        restartTimer();
      });
    }

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            isIntersecting = entry.isIntersecting;
            setPlayPauseUI();
            restartTimer();
          });
        },
        { threshold: 0.4 }
      );
      io.observe(root);

      // Separate, much more lenient observer for the control bar's
      // fade/rise-in: this one should trigger the instant any sliver of
      // the section is on screen, not only once the carousel is
      // prominently in view the way autoplay's own gate above should be.
      // It only drives the flourish -- where the bar sits, and when it
      // stops hovering over the bottom of the screen, is CSS `position:
      // sticky` inside the section, not this observer.
      if (controls) {
        const floatIo = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              controls.classList.toggle('is-floating', entry.isIntersecting);
            });
          },
          { threshold: 0.01 }
        );
        floatIo.observe(root);
      }
    } else {
      isIntersecting = true;
      if (controls) controls.classList.add('is-floating');
    }

    reduceMotion.addEventListener('change', () => {
      userWantsAutoplay = !reduceMotion.matches;
      setPlayPauseUI();
      restartTimer();
    });

    setActive(0);
    setPlayPauseUI();
  });
})();

(() => {
  // Homepage email pop-up: appears 2s after page load, once per visitor.
  //
  // Two separate localStorage keys, not one: "seen" (dismissed without
  // subscribing) and "subscribed" (submitted the form). A visitor who closes
  // it might still be worth asking again on a future visit; a visitor who
  // already gave an email should never be asked again. sessionStorage would
  // reset every new tab, which is not "once per visitor."
  const SEEN = 'auren_popup_seen';
  const DONE = 'auren_popup_subscribed';
  const DELAY = 2000;

  const popup = document.querySelector('[data-auren-email-popup]');
  if (!popup) return;

  const read = (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } };
  const write = (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} };

  // A successful submit round-trips back with this hash -- if that's how we
  // got here, remember it and don't show the pop-up again on this load.
  if (window.location.hash === '#AurenPopupSignup') write(DONE, '1');
  if (read(DONE) || read(SEEN)) return;

  let lastFocus = null;

  const close = () => {
    popup.hidden = true;
    document.documentElement.style.overflow = '';
    write(SEEN, '1');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };

  const open = () => {
    lastFocus = document.activeElement;
    popup.hidden = false;
    // Lock background scroll while open -- otherwise the page behind a
    // full-screen mobile pop-up can still be scrolled underneath it.
    document.documentElement.style.overflow = 'hidden';
    requestAnimationFrame(() => { popup.dataset.open = 'true'; });
    const field = popup.querySelector('input[type="email"]');
    if (field) setTimeout(() => field.focus(), 320);
  };

  const timer = setTimeout(open, DELAY);

  popup.querySelectorAll('[data-auren-popup-close]').forEach((btn) => {
    btn.addEventListener('click', close);
  });
  // Backdrop click closes; clicking the card itself does not.
  popup.addEventListener('click', (e) => { if (e.target === popup) close(); });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !popup.hidden) close();
  });
  const form = popup.querySelector('form');
  if (form) form.addEventListener('submit', () => { write(DONE, '1'); clearTimeout(timer); });

  // Trap focus inside the dialog while open.
  popup.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const f = popup.querySelectorAll('button, input, a[href]');
    if (!f.length) return;
    const first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });
})();

(() => {
  // Early Bird two-step mission unlock logic (sections/auren-vip-reservation.liquid).
  //
  // Step 1 is a Shopify {% form 'customer' %} -- submitting it is a full page
  // POST + redirect, so "step 1 is done" has to survive a fresh page load.
  // localStorage carries that, not an in-memory flag. The email itself is
  // also stored, purely so the completed state can echo it back
  // ("Sent to you@you.com") -- it has no other use here.
  const KEY = 'auren_eb_step1';
  const root = document.querySelector('[data-auren-eb]');
  if (!root) return;

  const step1 = root.querySelector('[data-eb-step1]');
  const step2 = root.querySelector('[data-eb-step2]');
  const rail = root.querySelector('[data-eb-rail]');
  if (!step1 || !step2 || !rail) return;

  const read = () => { try { return localStorage.getItem(KEY); } catch (e) { return null; } };
  const write = (v) => { try { localStorage.setItem(KEY, v); } catch (e) {} };

  const unlock = (email, animate) => {
    const live = step1.querySelector('[data-eb-live]');
    const done = step1.querySelector('[data-eb-done]');
    if (live) live.hidden = true;
    if (done) {
      done.hidden = false;
      // With an address, fill the slot in the normal copy. Without one, swap
      // to the generic paragraph -- leaving the slot empty rendered the
      // sentence as "Sent to ." on screen.
      const slot = done.querySelector('[data-eb-email]');
      const bodyWithEmail = done.querySelector('[data-eb-done-body]');
      const bodyGeneric = done.querySelector('[data-eb-done-body-generic]');
      if (email) {
        if (slot) slot.textContent = email;
      } else if (bodyWithEmail && bodyGeneric) {
        bodyWithEmail.hidden = true;
        bodyGeneric.hidden = false;
      }
    }

    step1.setAttribute('data-state', 'done');
    rail.setAttribute('data-step', '2');
    const n1 = root.querySelector('[data-eb-node1]');
    const n2 = root.querySelector('[data-eb-node2]');
    if (n1) { n1.setAttribute('data-state', 'done'); const d = n1.querySelector('[data-eb-dot1]'); if (d) d.innerHTML = '&check;'; }
    if (n2) n2.setAttribute('data-state', 'active');

    // Step 2 is never locked (Simon 2026-09-03) -- it renders fully usable
    // and its button is only ever disabled by Liquid when Shopify itself
    // reports the variant out of stock. So there is nothing to enable here:
    // finishing step 1 just highlights the card and drops the nudge.
    step2.classList.add('auren-eb-card--highlight');
    const hintNote = step2.querySelector('[data-eb-hint]');
    if (hintNote) hintNote.hidden = true;

    const teaser = root.querySelector('[data-eb-teaser]');
    if (teaser) {
      const after = teaser.getAttribute('data-after');
      if (after) teaser.textContent = after;
      const veil = root.querySelector('[data-eb-veil]');
      if (veil) veil.hidden = true;
    }

    if (animate) {
      step2.classList.add('is-sweeping');
      setTimeout(() => step2.classList.remove('is-sweeping'), 1000);
      // Deferred two frames, not called immediately. The browser's own
      // "scroll to the fragment" step (jumping to #AurenEarlyBirdStep1,
      // still in the URL when this first runs) can re-fire on its own while
      // the page is still settling, after this script has already run --
      // and that silently overwrote this scrollIntoView, which is why it
      // looked like step 2 was never actually being scrolled to (reported
      // live 2026-09-03). The hash is stripped from the URL below before
      // unlock() is even called, which removes that target going forward;
      // waiting two rAFs here on top of that lets any scroll the browser
      // was already mid-flight on settle first, so this one is the last
      // word rather than a race.
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          try { step2.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
          catch (e) { step2.scrollIntoView(); }
        });
      });
    }
  };

  // Just submitted step 1 and redirected back.
  const justPosted = window.location.search.indexOf('customer_posted=true') !== -1
    && window.location.hash === '#AurenEarlyBirdStep1';
  if (justPosted) {
    // Strip the query and the hash right away -- see the comment on the
    // deferred scrollIntoView below for why the hash has to go before that
    // runs, not after.
    window.history.replaceState({}, document.title, window.location.pathname);
    const saved = read();
    unlock(saved && saved !== '1' ? saved : '', true);
  } else {
    // Or it was already done on a previous visit.
    const saved = read();
    if (saved) unlock(saved === '1' ? '' : saved, false);
  }

  // Remember the email BEFORE the page navigates away on submit, so it is
  // there to display once Shopify redirects back.
  const form = step1.querySelector('form');
  if (form) {
    form.addEventListener('submit', () => {
      const field = form.querySelector('input[type="email"]');
      if (field && field.value) write(field.value.trim());
    });
  }
})();

/* ============================================================
   Homepage section 4 -- "Product System" mode-selection gallery

   Three user-driven pieces, no autoplay anywhere:
   - tablist that swaps the visible panel (hardware / app / findpet)
   - hardware: drag-to-rotate turntable scrubbing the same render frames
     Meet Ouren M1 already streams (frames 56-262 are one full turn, so
     the HTTP cache is warm by the time a visitor gets here)
   - app: dots synced to the native scroll-snap swipe inside the phone

   Progressive enhancement: the markup renders stacked and readable with
   no JS; this adds .auren-system--live to enable the tabbed behaviour,
   exactly like .auren-meet--live above.
   ============================================================ */
(() => {
  const roots = Array.from(document.querySelectorAll('[data-auren-system]'));
  if (!roots.length) return;

  roots.forEach((root) => {
    const tabs = Array.from(root.querySelectorAll('[data-system-mode]'));
    const panels = Array.from(root.querySelectorAll('[data-system-panel]'));
    if (!tabs.length || !panels.length) return;

    root.classList.add('auren-system--live');

    // ---- mode switching (ARIA tabs pattern) ----
    const setMode = (name, { focusTab } = {}) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.systemMode === name;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focusTab) tab.focus();
      });
      panels.forEach((panel) => {
        panel.classList.toggle('is-active', panel.dataset.systemPanel === name);
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => setMode(tab.dataset.systemMode));
    });

    const tablist = root.querySelector('[data-system-modes]');
    if (tablist) {
      tablist.addEventListener('keydown', (event) => {
        const current = tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        let next = -1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (current + 1) % tabs.length;
        else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (current - 1 + tabs.length) % tabs.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = tabs.length - 1;
        if (next < 0) return;
        event.preventDefault();
        setMode(tabs[next].dataset.systemMode, { focusTab: true });
      });
    }

    setMode('hardware');

    // ---- hardware turntable ----
    const turntable = root.querySelector('[data-system-turntable]');
    const canvas = root.querySelector('[data-system-spin]');
    const hint = root.querySelector('[data-system-hint]');
    if (turntable && canvas) {
      const ctx = canvas.getContext('2d');
      const base = root.dataset.seqBase || '';
      const suffix = root.dataset.seqSuffix || '';
      const start = parseInt(root.dataset.spinStart, 10) || 56;
      const end = parseInt(root.dataset.spinEnd, 10) || 262;
      const step = parseInt(root.dataset.spinStep, 10) || 2;

      // Frame list for one revolution. The end frame is visually the same
      // front pose as the start frame (both are turnaround anchors), so it
      // is EXCLUDED -- including it would show the same pose twice at the
      // wrap point and read as a stutter mid-drag.
      const indices = [];
      for (let i = start; i < end; i += step) indices.push(i);
      const count = indices.length;

      const frames = new Array(count);
      const ready = new Array(count).fill(false);
      let current = 0;
      let lastDrawn = -1;
      let initialized = false;
      let hintDismissed = false;

      const frameUrl = (i) =>
        base + 'auren-m1-seq-' + String(indices[i]).padStart(3, '0') + '.webp' + suffix;

      const sizeCanvas = () => {
        const w = canvas.offsetWidth;
        if (!w) return;
        const dpr = Math.min(window.devicePixelRatio || 1, 2);
        const px = Math.round(w * dpr);
        if (canvas.width !== px) {
          canvas.width = px;
          canvas.height = px;
          lastDrawn = -1;
        }
      };

      const draw = (i) => {
        if (!ready[i] || i === lastDrawn) return;
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(frames[i], 0, 0, canvas.width, canvas.height);
        lastDrawn = i;
      };

      const loadFrame = (i, done) => {
        if (frames[i]) return;
        const img = new Image();
        img.decoding = 'async';
        img.onload = () => {
          ready[i] = true;
          if (done) done(i);
        };
        img.src = frameUrl(i);
        frames[i] = img;
      };

      const init = () => {
        if (initialized) return;
        initialized = true;
        sizeCanvas();
        // Front pose first so the still can be swapped out immediately;
        // the rest stream in small batches behind it (usually straight
        // from the HTTP cache, thanks to section 2).
        loadFrame(0, () => {
          turntable.classList.add('is-ready');
          sizeCanvas();
          draw(0);
        });
        let n = 1;
        const batch = () => {
          const stop = Math.min(n + 8, count);
          for (; n < stop; n += 1) loadFrame(n, (i) => { if (i === current) draw(i); });
          if (n < count) window.setTimeout(batch, 80);
        };
        batch();
      };

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                init();
                io.disconnect();
              }
            });
          },
          { rootMargin: '400px 0px' }
        );
        io.observe(root);
      } else {
        init();
      }

      // Nearest loaded frame at/behind the requested one, so a fast drag
      // mid-stream shows slightly coarser rotation instead of blanks.
      const nearestReady = (i) => {
        for (let d = 0; d < count; d += 1) {
          const back = (i - d + count) % count;
          if (ready[back]) return back;
          const fwd = (i + d) % count;
          if (ready[fwd]) return fwd;
        }
        return -1;
      };

      let dragging = false;
      let dragStartX = 0;
      let dragStartFrame = 0;

      turntable.addEventListener('pointerdown', (event) => {
        if (!initialized) init();
        dragging = true;
        dragStartX = event.clientX;
        dragStartFrame = current;
        turntable.classList.add('is-dragging');
        // Capture keeps the drag alive when the pointer leaves the element,
        // but must never break the drag itself: some pointer sources (and
        // synthetic events) have ids that can't be captured, and that throws.
        try {
          turntable.setPointerCapture(event.pointerId);
        } catch (e) {
          /* drag still works without capture */
        }
        if (hint && !hintDismissed) {
          hintDismissed = true;
          hint.classList.add('is-hidden');
        }
      });

      turntable.addEventListener('pointermove', (event) => {
        if (!dragging) return;
        const dx = event.clientX - dragStartX;
        // One full drag across the turntable's own width = one full turn.
        // Dragging right spins the device the way a physical object would
        // roll under your hand.
        const deltaFrames = Math.round((dx / turntable.offsetWidth) * count);
        const target = (((dragStartFrame - deltaFrames) % count) + count) % count;
        if (target === current) return;
        current = target;
        const shown = ready[target] ? target : nearestReady(target);
        if (shown >= 0) draw(shown);
      });

      const endDrag = () => {
        dragging = false;
        turntable.classList.remove('is-dragging');
      };
      turntable.addEventListener('pointerup', endDrag);
      turntable.addEventListener('pointercancel', endDrag);

      window.addEventListener('resize', () => {
        sizeCanvas();
        const shown = ready[current] ? current : nearestReady(current);
        if (shown >= 0) draw(shown);
      });
    }

    // ---- app screens: dots follow the native scroll-snap swipe ----
    const screens = root.querySelector('[data-system-screens]');
    const dotsWrap = root.querySelector('[data-system-screen-dots]');
    if (screens && dotsWrap) {
      const dots = Array.from(dotsWrap.children);
      let ticking = false;
      // Slides here are exactly the track's own width (flex: 0 0 100%),
      // so unlike section 3's variable-width cards the simple division
      // is the correct math.
      const sync = () => {
        ticking = false;
        const index = Math.round(screens.scrollLeft / screens.clientWidth);
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
      };
      screens.addEventListener(
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(sync);
        },
        { passive: true }
      );
    }
  });
})();
